import React, { useState } from 'react';
import * as Yup from 'yup';
import { t } from 'i18next';
import { useFormik } from 'formik';

import toast from 'react-hot-toast';
import { Close } from '@mui/icons-material';
import { EditIcon } from '../../../../assets/images/icons'; // Replace with correct import for the icon
import { useDispatch, useSelector } from 'react-redux';

import Button from '../../Buttons/Button/Button';
import styles from './EditPortfolio.module.css';
import Subtitle from '../Subtitle/Subtitle';
import BasicPopup from '../../Popups/BasicPopup/BasicPopup';
import PortfolioForm from '../../../Forms/Common/PortfolioForm/PortfolioForm'; // Create this form component
import PortfolioList from '../Portfolio/PortfolioList/PortfolioList'; // Create this component to display portfolio items
import { updateUser } from '../../../../services/userService';
import { fetchUserByToken, fetchUserByTokenWithoutLoading } from '../../../../app/features/userSlice';

function EditPortfolio() {
    const user = useSelector(state => state.user.user);
    const [formLoading, setFormLoading] = useState(false);
    const [editMode, setEditMode] = useState(false);
    const [isOpenPortfolioPopup, setIsOpenPortfolioPopup] = useState(false);
    const [editItem, setEditItem] = useState(null); // Track the item being edited

    const userToken = useSelector(state => state.user.token);
    const dispatch = useDispatch();
    const formattedPortfolioItems = user.portfolio ? user.portfolio.map(item => ({
        id: item.id,
        title: item.title,
        description: item.description,
        role: item.role,
        media: item.media,
        media2: item.media2,
        media3: item.media3,
        media4: item.media4,
        media5: item.media5,
    })) : [];
    const submitUpdateUser = async (values) => {
        if (formLoading) {
            return;
        }
        setFormLoading(true);
        const formData = new FormData();
        formData.append('token', userToken);
        if (values.portfolioItems.length > 0) {
            if (values.portfolioItems.length > 20) {
                values.portfolioItems = await values.portfolioItems.slice(values.portfolioItems.length - 20, values.portfolioItems.length)
            }
            values.portfolioItems.forEach((item, index) => {
                if (index < 20) {
                    if (item?.action === 'add_new') {
                        formData.append(`portfolio[${index}][title]`, item.title);
                        formData.append(`portfolio[${index}][description]`, item.description);
                        formData.append(`portfolio[${index}][role]`, item.role);
                        formData.append(`portfolio[${index}][media]`, item.media);
                        formData.append(`portfolio[${index}][media2]`, item.media2);
                        formData.append(`portfolio[${index}][media3]`, item.media3);
                        formData.append(`portfolio[${index}][media4]`, item.media4);
                        formData.append(`portfolio[${index}][media5]`, item.media5);
                        formData.append(`portfolio[${index}][id]`, 0);
                    } else if (item?.action === 'update') {
                        formData.append(`portfolio[${index}][title]`, item.title);
                        formData.append(`portfolio[${index}][description]`, item.description);
                        formData.append(`portfolio[${index}][role]`, item.role);
                        formData.append(`portfolio[${index}][media]`, item.media);
                        formData.append(`portfolio[${index}][media2]`, item.media2);
                        formData.append(`portfolio[${index}][media3]`, item.media3);
                        formData.append(`portfolio[${index}][media4]`, item.media4);
                        formData.append(`portfolio[${index}][media5]`, item.media5);
                        formData.append(`portfolio[${index}][id]`, item.id);
                        // formData.append(`portfolio[${index}][id]`, 0);
                    }
                    else {
                        formData.append(`portfolio[${index}][id]`, item.id);
                    }
                }
            });
            // }
        } else {
            formData.append('portfolio', '');
        }

        toast.promise(updateUser(formData), {
            loading: t('edit_profile.updating_profile'),
            success: <b>{t('edit_profile.profile_updated')}</b>,
            error: (err) => <b>{err.response.data.error}</b>,
        }).then(async () => {
            await dispatch(fetchUserByTokenWithoutLoading(userToken));
            await setEditMode(!editMode)
            await setFormLoading(false);
        }).catch((error) => {
            setFormLoading(false);
            if (error?.response?.data?.field) {
                formik.setErrors({
                    [error.response.data.field]: error.response.data.error
                });
            }
        });
    }

    const formik = useFormik({
        initialValues: {
            portfolioItems: formattedPortfolioItems,
        },
        validationSchema: Yup.object({
            portfolioItems: Yup.array().of(
                Yup.object({
                    title: Yup.string().required(t('validation.required')),
                    description: Yup.string().required(t('validation.required')),
                    role: Yup.string().required(t('validation.required')),
                    media: Yup.string().required(t('validation.required')),
                    // media2: Yup.string(),
                    // media3: Yup.string(),
                    // media4: Yup.string(),
                    // media5: Yup.string(),
                })
            ),
        }),
        onSubmit: submitUpdateUser
    });

    const handlePopupClose = () => {
        setIsOpenPortfolioPopup(false);
        setEditItem(null); // Clear the edit item when closing the popup

    }

    const handlePopupOpen = (item) => {
        setIsOpenPortfolioPopup(true);
    }

    const handleOptionRemove = async (id) => {
        const filteredItems = await formik.values.portfolioItems.filter((item) => item.id !== id);
        await formik.setFieldValue('portfolioItems', filteredItems);
        submitUpdateUser({
            ...formik.values,
            portfolioItems: filteredItems, // Pass the updated portfolioItems explicitly
        });
    }

    const handleAddPortfolioItem = (values) => {
        formik.setFieldValue('portfolioItems', [
            ...formik.values.portfolioItems,
            { id: Date.now(), action: 'add_new', ...values }
        ]);
        handlePopupClose();
        submitUpdateUser({
            ...formik.values,
            portfolioItems: [
                ...formik.values.portfolioItems,
                { id: Date.now(), action: 'add_new', ...values }
            ],
        });
    }
    const handleEditPortfolioItem = (values) => {
        const updatedItems = formik.values.portfolioItems.map(item => {
            const alreadyHaveIdDb = formattedPortfolioItems.findIndex((e) => e.id === editItem.id)
            return (item.id === editItem.id ?
                alreadyHaveIdDb == -1 ?
                    { ...item, ...values, action: 'add_new' } :
                    { ...item, ...values, action: 'update' } : item)
        }
        );
        formik.setFieldValue('portfolioItems', updatedItems);
        submitUpdateUser({
            ...formik.values,
            portfolioItems: updatedItems,
        });
        handlePopupClose();
    }

    return (
        <div className={styles.container}>
            <div className={styles.secondColumn}>
                <div className={styles.title}>
                    {t(`profileSidebar.tabs.portfolio`)}
                </div>
                {editMode ? (
                    <>
                        {/* <PortfolioList portfolios={formik.values.portfolioItems}
                            className={styles.portfolioList} /> */}
                        <PortfolioList
                            portfolios={formik.values.portfolioItems}
                            className={styles.portfolioList}
                            onEdit={handlePopupOpen}
                            setEditItem={setEditItem}
                            onRemove={handleOptionRemove}
                        />
                    </>
                ) : (
                    <div className={styles.editContainer}>
                        <div style={{ margin: "10px 0px" }}>
                            <Subtitle
                                dark
                                hasButton
                                style={{ marginBottom: '0px' }}
                                buttonText={t('general.UI.add')}
                                buttonOnClick={handlePopupOpen}
                            >
                                {t('profileSidebar.tabs.portfolio')}
                            </Subtitle>
                        </div>
                        <PortfolioList
                            portfolios={formik.values.portfolioItems}
                            className={styles.portfolioList}
                            onEdit={handlePopupOpen}
                            setEditItem={setEditItem}
                            onRemove={handleOptionRemove}
                        />
                    </div>
                )}
            </div>

            {isOpenPortfolioPopup && (
                <BasicPopup
                    isOpen={isOpenPortfolioPopup}
                    closePopup={handlePopupClose}
                >
                    <PortfolioForm
                        editItem={editItem}
                        onSubmit={(values) => {
                            if (editItem) {
                                setEditItem(values)
                                handleEditPortfolioItem(values)
                            } else {
                                handleAddPortfolioItem(values)
                            }
                        }
                        }
                    />
                </BasicPopup>
            )}

        </div>
    );
}

export default EditPortfolio;
